import React from 'react';
import * as Sentry from '@sentry/react';

interface Props {}

/**
 *
 * Top Level Error Boundary component, reports directly to Sentry.
 * Notice that every error that bubbles up here is uncaught and tagged as critical, so capture your errors.
 */
const ErrorBoundary: React.FC<Props> = ({ children }) => {
  // onBeforeCapture let you attach tags and other data
  // related to the current application state
  // (e.g. spotId, userId, currentRoute, etc.)
  const onBeforeCapture = (
    scope: Sentry.Scope,
    error: Error | null,
    componentStack: string | null
  ): void => {
    scope.setLevel(Sentry.Severity.Critical);
  };

  return (
    <Sentry.ErrorBoundary beforeCapture={onBeforeCapture} showDialog>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
